const extractTextFromHTML = (html: string | null = ''): string => (
  typeof html === 'string' ? html.replace(/<[^>]+>/g, '').trim() : ''
);

export default extractTextFromHTML;
